export default __webpack_public_path__ + "static/media/instagram-icn-about-mobile.e915382e.svg";